export default __webpack_public_path__ + "static/media/paul_gilbert_novotel.dadc6532.jpg";